/**
 * Runtime Configuration
 * 
 * Получает конфигурацию из:
 * 1. window.__APP_CONFIG__ (runtime, приоритет)
 * 2. import.meta.env (build-time, fallback)
 * 
 * Это позволяет менять конфигурацию без пересборки приложения.
 */

// Типизация window config
declare global {
  interface Window {
    __APP_CONFIG__?: {
      YANDEX_MAPS_API_KEY?: string;
      API_URL?: string;
    };
  }
}

/**
 * Получить значение конфигурации
 * Приоритет: runtime config > build-time env > fallback
 */
function getConfigValue(key: string, envKey: string, fallback = ''): string {
  // 1. Runtime config (window.__APP_CONFIG__)
  const runtimeValue = window.__APP_CONFIG__?.[key as keyof typeof window.__APP_CONFIG__];
  if (runtimeValue && !runtimeValue.startsWith('__')) {
    return runtimeValue;
  }
  
  // 2. Build-time env (import.meta.env)
  const envValue = import.meta.env[envKey];
  if (envValue) {
    return envValue;
  }
  
  // 3. Fallback
  return fallback;
}

/**
 * Application Configuration
 */
export const config = {
  /** Yandex Maps API Key */
  get yandexMapsApiKey(): string {
    return getConfigValue('YANDEX_MAPS_API_KEY', 'VITE_YANDEX_MAPS_API_KEY');
  },
  
  /** API Base URL */
  get apiUrl(): string {
    return getConfigValue('API_URL', 'VITE_API_URL', '');
  },
  
  /** Check if Yandex Maps is configured */
  get hasYandexMaps(): boolean {
    const key = this.yandexMapsApiKey;
    return !!key && key.length > 10;
  },
} as const;
